import {Model} from "./base/Model";
import {Collection} from "./base/Collection";
import { v4 as uuid } from "uuid";
import DateHelperClass from '@/helpers/DateHelper'    
import moment from 'moment';

export class TimerModel extends Model {
      key: string = "";
      hours: number = 0;
      minutes: number = 0;
      seconds: number = 0;
      timeHolder:  Collection = new Collection();
      state: number = 0;
      startTime: number;
      endTime: number;
    
        constructor(data = null) {
            super();
            
            if(data) {
                this.createModel(data);
                if(data["timeHolder"]) {
                    this["timeHolder"] = new Collection(data["timeHolder"], TimerTimeModel);
                    }
                    if(data["state"] == 1) {
                        this.setActive(1);
                        }
    
            }
            
        }      

        public getStartDate() {
            let retVal  = '';
            retVal = DateHelperClass.getDate(this.startTime, 'YYYY-MM-DD');
            
            return retVal;
        }
        
        public getTotalTimeInMinutes() {
            let retVal  = 0;
            retVal = DateHelperClass.getTotalminutes(this.hours, this.minutes);
            
            return retVal;
        }
        
        public calculateTotalTime(withUpdate = true) {
            if(withUpdate) {
                this.updateTime();
            }
            let totalHours = 0
            let totalMinutes = 0;
            let totalSeconds = 0;
            this.timeHolder.for((item) => {
                this.startTime = item.startTime;
                totalHours += item.hours;
                totalMinutes += item.minutes
                totalSeconds += item.seconds;
            })
            this.hours = totalHours;
            this.minutes = totalMinutes;
            this.seconds = totalSeconds;
        }
        
        public createNewTimer() {
            let startTime = moment.utc().valueOf();
            let timeModel = new TimerTimeModel({startTime: startTime});
            this.timeHolder.add(timeModel);
            
            //this.state = 1;
        }

        public setActive(activeState) {
            let lastTimerTimeModel = this.getLastTimerModel();
            lastTimerTimeModel.setActive(activeState, this);
            this.state = activeState;
            return lastTimerTimeModel;
        }
        
        public updateTime() {
            let lastTimerTimeModel = this.getLastTimerModel();
            return lastTimerTimeModel.updateTimeVal(lastTimerTimeModel);
        }
        
        public getLastTimerModel() {
            let timerModel = this.timeHolder.last();
            
            return timerModel;
        }

        public pauseTimer() {
            let lastTimerTimeModel = this.setActive(5);
            lastTimerTimeModel.endTime = moment.utc().valueOf();
            this.calculateTotalTime();             
        }
        
        public stopTimer() {
            let lastTimerTimeModel = this.setActive(0);
            lastTimerTimeModel.endTime = moment.utc().valueOf();
            this.calculateTotalTime();             
        }
    }
    
    export class TimerTimeModel extends Model {
          key: string = "";
          hours: number = 0;
          minutes: number = 0;
          seconds: number = 0;
          startTime: number;
          endTime: number;
          private timerId: any;
                  
            constructor(data = null) {
                super();
                if(data) {
                    if(data["timerId"]) {
                        delete data["timerId"];
                    }
                    this.createModel(data);
                }
            }      
            
            public setActive(activeState, parent = null) {
                if(this.timerId) {
                    clearInterval(this.timerId);
                    this.timerId = null;
                }
                
                if( (activeState == 0 || activeState == 5) && this.timerId) {
                    clearInterval(this.timerId);
                } else if(activeState == 1 && !this.timerId) {
                    let self = this;

                    let currentTime = moment.utc();
                    let startTimeObj = moment(this.startTime);
                    var duration = moment.duration(currentTime.diff(startTimeObj));
                    
                    let firstDuration = 1000- duration.get('milliseconds');
                    this.createNewInterval(firstDuration, parent);                    
                }
                
            }
            
            private createNewInterval(duration, parent = null) {
                let self = this;
                let newTimerId = setInterval(() => {
                    let isChanged = this.updateTimeVal(self, parent);
                    if(duration != 1000) {
                        clearInterval(newTimerId);
                        this.createNewInterval(1000, parent);
                    } 
                            
                }, duration);
                this.timerId = newTimerId;
            }
            
            public updateTimeVal(model, parent = null) {
                let currentTime = moment.utc();
                let startTimeObj = moment(model.startTime);
                var duration = moment.duration(currentTime.diff(startTimeObj));

                let curHours   = duration.get('hours');
                let minutes = duration.get('minutes');
                let seconds = duration.get('seconds');   
                model.seconds = seconds;
                
                // || lastTimerModel.seconds != seconds
                
                
                if(model.hours != curHours || model.minutes != minutes ) {
                    model.minutes = minutes;
                    model.hours = curHours;
                    parent.calculateTotalTime(false);
                    const event = new CustomEvent("timer.update_"+model.uid, {detail: {timerModel:model} });
                    event["data"] = "testje";
                    window.dispatchEvent(event);
                    return true;          
                }
            }
        }    